export enum HubspotEnrichmentManualJobExecutionMode {
  COMPLETE = "COMPLETE",
  REVIEW = "REVIEW",
}
